<template>
  <div class="container flex">
    <div class="tabs-wrap">
      <div
        :class="['tabs-item',tabActive === index ? 'active' : '']"
        v-for="(item,index) in tabList"
        :key="index"
        @click="handChangeTabs(index)"
      >{{ item.name }}</div>
    </div>
    <div class="content">
      <el-tabs type="border-card" v-model="tabTwoActive">
        <el-tab-pane :label="item.name" v-for="item in tabTwoList" :key="item.id"></el-tab-pane>
      </el-tabs>
      <div style="margin-top: 20px;justify-content: space-between;" class="flex">
        <el-input placeholder="请输入项目名称进行搜索" v-model="keyWord" class="input-with-select" style="width:420px;">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
        <el-button
          type="primary"
          style="background: #0758FF;"
          @click="routeJump"
          v-if="tabActive == 0"
        >申报项目</el-button>
        <el-button
          type="primary"
          style="background: #0758FF;"
          @click="routeJump"
          v-if="tabActive == 2"
        >新增实施方案</el-button>
      </div>
      <div class="project-wrap">
        <div class="project-item">
          <div class="project-item-header flex">
            <div class="project-item-header_title double-ellipsis">
              <!-- type="danger" -->
              <el-tag style="margin-right: 10px;">待审核</el-tag>XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
            </div>
            <div class="project-item-header-operate flex">
              <div class="project-item-header-operate-item" @click="routeDetail()">详情</div>
              <div class="project-item-header-operate-item" @click="routeJump()">修改</div>
            </div>
          </div>
          <div class="project-item-info flex">
            <div class="project-item-info-text">项目编码：XM23642754312</div>
            <div class="project-item-info-text">项目类别：海洋文化产业</div>
            <div class="project-item-info-text">项目负责人：李斯</div>
            <div class="project-item-info-text">申报时间：2025-05-28 15:30:32</div>
          </div>
        </div>
      </div>
      <div class="pagination-wrap flex">
        <el-pagination
          :current-page="tablePagesProps.current"
          :page-size="tablePagesProps.size"
          :page-sizes="pageSizes"
          background
          :layout="pagesLayout"
          :total="tableTotal"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "xmgcglPage",
  data() {
    return {
      keyWord:'',
      tabList: [
        { name: "项目申报", id: 1 },
      ],
      tabActive: 0,
      tabTwoList: [
        { name: "全部(2)", id: 1 },
        { name: "待审核(2)", id: 2 },
        { name: "审核中(2)", id: 3 },
        { name: "审核不通过(5)", id: 5 }
      ],
      tabTwoActive: 0,
      tablePagesProps: {
        current: 1,
        size: 10
      },
      pageSizes: [10, 20, 30, 40, 50, 100],
      pagesLayout: "total, sizes, prev, pager, next, jumper",
      tableTotal: 10
    };
  },
  methods: {
    handChangeTabs(index) {
      this.tabActive = index;
    },
    handleSizeChange(e) {
      console.log(
        "%c e",
        "background-color: #2196f3; padding: 3px 6px; border-radius: 2px; font-size: 12px; color: #fff;",
        e
      );
    },
    handleCurrentChange(e) {
      console.log(
        "%c e",
        "background-color: #2196f3; padding: 3px 6px; border-radius: 2px; font-size: 12px; color: #fff;",
        e
      );
    },
    routeJump() {
      this.$router.push("/xmsbApply");
    },
    routeDetail() {
      this.$router.push("/xmsbDetail");
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 1200px;
  margin: 0 auto 40px;
}
.tabs {
  &-wrap {
    padding: 16px 10px;
    width: 160px;
    height: fit-content;
    box-sizing: border-box;
    background-color: #ffffff;
    box-shadow: 0px 2px 8px 0px rgba(194, 202, 217, 0.5);
    border-radius: 4px;
    margin-right: 20px;
  }
  &-item {
    font-weight: 400;
    font-size: 14px;
    color: #606266;
    line-height: 14px;
    padding: 16px 14px;
    cursor: pointer;
    &.active {
      background: #ecf5ff;
      border-radius: 4px;
      color: #0758ff;
    }
  }
}
.content {
  flex: 1;
  padding: 20px;
  box-sizing: border-box;
  background: #ffffff;
}
::v-deep {
  .el-tabs--border-card > .el-tabs__content {
    padding: 0;
  }
  .el-tabs--border-card > .el-tabs__header,
  .el-tabs--border-card {
    border-bottom: 0;
    box-shadow: none;
  }
  .el-button el-button--default {
    background: #f4f7ff;
  }
}

.project {
  &-wrap {
    margin-top: 40px;
  }
  &-item {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #dcdfe6;
    &-header {
      margin-bottom: 12px;
      &_title {
        flex: 1;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        line-height: 16px;
      }
      &-operate {
        &-item {
          cursor: pointer;
          font-weight: 400;
          font-size: 14px;
          color: #0758ff;
          line-height: 14px;
          margin-left: 20px;
        }
      }
    }
    &-info {
      &-text {
        font-weight: 400;
        font-size: 14px;
        color: #909399;
        line-height: 14px;
        margin-right: 40px;
      }
    }
  }
}

.pagination-wrap {
  justify-content: flex-end;
}
</style>